export {
  ENTITY_NAME,
  RESOURCE_NAME,
} from '@/features/purchasesStatistics/consts';
